import { memo, useMemo } from "react";
import _get from "lodash/get";
import { IAppContextStore, useAppContext } from "../../../context/app-context";
import { filterItems } from "../../../helpers/contentful-helper";
import { Entry } from "contentful";
import { ISharedInformationSection } from "./shared-information-section.types";

const SharedInformationSection: React.FC = () => {
  const { rawContentFul }: IAppContextStore = useAppContext();
  const sharedInformationSection: Entry<ISharedInformationSection> = useMemo(() => (
    filterItems(rawContentFul, 'newHomepageSharedInformationSection')?.[0]
  ) as Entry<ISharedInformationSection>, [rawContentFul]);

  return (
    <section className="bg-[#F83D11] text-white py-16 px-4">
      <div className="max-w-3xl mx-auto w-full text-center">
        <h2 className="text-22 md:text-40 leading-30 md:leading-48 font-bold mb-6 font-inter">
          {_get(sharedInformationSection, 'fields.title', '')}
        </h2>
        <p className="text-18 md:text-20 leading-7 mb-4 font-sans">
          {_get(sharedInformationSection, 'fields.description', '')}
        </p>
      </div>
    </section>
  )
};

export default memo(SharedInformationSection);
